module.exports = __webpack_public_path__ + "img/logo-map-marker.4146dc6c.svg";